const galleryPath = '/gallery';
export const getGallery = galleryPath;
export const updateGalleryImagesOrder = `${galleryPath}/order`;
export const getGalleryImageId = (id: number) => `${galleryPath}/${id}`;
export const createGalleryImage = galleryPath;
export const updateGalleryImage = (id: number) => `${galleryPath}/${id}`;
export const updateGalleryImageStatus = (id: number) => `${galleryPath}/${id}/activation`;
